import { Col } from "react-grid-system";
import styles from "./DataPanelContent.module.css";
import { CollectionsDataPanel } from "../../../lib/api/models";
import DetailsRow from "../../DetailsRow";
import {
  convertDateStringToMonthDayYearFormat,
  validateBeforeCentsToDollarString,
} from "../../../lib/formatting";
import Tooltip from "../../common/Tooltip";

const strings = {
  pricingLockEndDate: "Pricing Lock End Dt",
  pricingMinimumPaymentDueCents: "Pricing Min Pmt Due",
  pricingMinimumPaymentHoverTitle: "Pricing MPD Calc Mthd",
  oneCycleDelinquentAmountCents: "1Cycle Delq Amt",
  twoCycleDelinquentAmountCents: "2Cycle Delq Amt",
  threeCycleDelinquentAmountCents: "3Cycle Delq Amt",
  fourCycleDelinquentAmountCents: "4Cycle Delq Amt",

  fiveCycleDelinquentAmountCents: "5Cycle Delq Amt",
  sixCycleDelinquentAmountCents: "6Cycle Delq Amt",
  sevenCycleDelinquentAmountCents: "7Cycle Delq Amt",
  nextWorkDate: "Next Wrk Dt",

  autoReageDate: "Auto Reage Dt",
  reageCount: "Reage Cnt (After 12/31/2000)",
  totalAutoReage: "Total Auto Reage (After 12/31/2000)",
  lastTrueReageCode: "Last True Reage Cd",
  lastReageDate: "Last Reage Dt",

  lastTrueWorkoutCode: "Last True Wrkt Cd",
  lastWorkoutDate: "Last Wrkt Dt",
  prevTrueReageCode: "Prev True Reage Cd",
  prevReageDate: "Prev Reage Dt",
  prevTrueWorkoutCode: "Prev True Wrkt Cd",
  prevWorkoutDate: "Prev Wrkt Dt",

  priorTrueReageCode: "Prior True Reage Cd",
  priorReageDate: "Prior Reage Dt",
  workoutPlanStartDate: "Wrkt Plan Start Dt",
  delinquentStartDate: "Delq Start Dt",
  entryDate: "Entry Dt",
  chargeOffDateAmount: "Charge Off Dt / Amt",
};

export default function CollectionsInnerContent(
  data: CollectionsDataPanel & {
    forecastMinPayDueHoverDescription?: string | null;
  },
) {
  return (
    <>
      <Col xs={2}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.pricingLockEndDate}
          value={convertDateStringToMonthDayYearFormat(data.pricingLockEndDate)}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.pricingMinimumPaymentDueCents}
          value={data.pricingMinimumPaymentDueAmount}
          tooltip={
            <Tooltip header={strings.pricingMinimumPaymentHoverTitle}>
              {data.forecastMinPayDueHoverDescription}
            </Tooltip>
          }
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.oneCycleDelinquentAmountCents}
          value={validateBeforeCentsToDollarString(
            data.oneCycleDelinquentAmountCents,
            true,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.twoCycleDelinquentAmountCents}
          value={validateBeforeCentsToDollarString(
            data.twoCycleDelinquentAmountCents,
            true,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.threeCycleDelinquentAmountCents}
          value={validateBeforeCentsToDollarString(
            data.threeCycleDelinquentAmountCents,
            true,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.fourCycleDelinquentAmountCents}
          value={validateBeforeCentsToDollarString(
            data.fourCycleDelinquentAmountCents,
            true,
          )}
        />
      </Col>
      <Col xs={2}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.fiveCycleDelinquentAmountCents}
          value={validateBeforeCentsToDollarString(
            data.fiveCycleDelinquentAmountCents,
            true,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.sixCycleDelinquentAmountCents}
          value={validateBeforeCentsToDollarString(
            data.sixCycleDelinquentAmountCents,
            true,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.sevenCycleDelinquentAmountCents}
          value={validateBeforeCentsToDollarString(
            data.sevenCycleDelinquentAmountCents,
            true,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.nextWorkDate}
          value={convertDateStringToMonthDayYearFormat(data.nextWorkDate)}
        />
      </Col>
      <Col xs={2}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.autoReageDate}
          value={convertDateStringToMonthDayYearFormat(data.autoReageDate)}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.reageCount}
          value={data.reageCount.toString()}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.totalAutoReage}
          value={data.totalAutoReage.toString()}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastTrueReageCode}
          value={data.lastTrueReageCode}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastReageDate}
          value={convertDateStringToMonthDayYearFormat(data.lastReageDate)}
        />
      </Col>
      <Col xs={2}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastTrueWorkoutCode}
          value={data.lastTrueWorkoutCode}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastWorkoutDate}
          value={convertDateStringToMonthDayYearFormat(data.lastWorkoutDate)}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.prevTrueReageCode}
          value={data.prevTrueReageCode}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.prevReageDate}
          value={convertDateStringToMonthDayYearFormat(data.prevReageDate)}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.prevTrueWorkoutCode}
          value={data.prevTrueWorkoutCode}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.prevWorkoutDate}
          value={convertDateStringToMonthDayYearFormat(data.prevWorkoutDate)}
        />
      </Col>
      <Col xs={3}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.priorTrueReageCode}
          value={data.priorTrueReageCode}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.priorReageDate}
          value={convertDateStringToMonthDayYearFormat(data.priorReageDate)}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.workoutPlanStartDate}
          value={convertDateStringToMonthDayYearFormat(
            data.workoutPlanStartDate,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.delinquentStartDate}
          value={convertDateStringToMonthDayYearFormat(
            data.delinquentStartDate,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.entryDate}
          value={convertDateStringToMonthDayYearFormat(data.entryDate)}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.chargeOffDateAmount}
          value={`${convertDateStringToMonthDayYearFormat(data.chargeOffDate)} / ${validateBeforeCentsToDollarString(data.chargeOffAmountCents)}`}
        />
      </Col>
    </>
  );
}
